import { render } from "./ReumatologiePage.vue?vue&type=template&id=79216ef7"
import script from "./ReumatologiePage.vue?vue&type=script&lang=js"
export * from "./ReumatologiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__